// extracted by css-extract-rspack-plugin
export default {"listNone":"_b0765807","details":"_6d644fad","chevron":"_93c6da04","chevronOpen":"_6c27ddf0"};